            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
          <sw-inputs
            inputTabla="datos_contacto"
            inputCampo="documento"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_contacto"
            inputCampo="name"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_contacto"
            inputCampo="direccion"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_contacto"
            inputCampo="email"
            :lg="6">
          </sw-inputs>
          <sw-inputs
            inputTabla="datos_contacto"
            inputCampo="telefonos"
            :lg="6">
          </sw-inputs>
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="contacto"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalcontacto',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  async created()
  {
    if (this.dataIndex[this.namePath]!==false)
    {      
      await this.updateDataForm({state:'datos_contacto', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_contacto})
    
    }
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  destroyed()
  {    
		this.resetDataIndex()
		this.resetDataForm()
  },
  computed: { 
  },
  methods: {
    save(event)
    {
     this.$emit('save', { save: event.save, ftn: 'contactoFtn' } )
    }
  }
}
</script>
<style>
</style>